import type { AssetTagsProps } from './types';
import { AssetTagList } from './AssetTagList';

export const AssetTags = (props: AssetTagsProps) => {
    const matchingTags = props.tags
        .filter(t => props.assetTags.includes(t.id))
        .sort((t1, t2) => t1.name.toLowerCase().localeCompare(t2.name.toLowerCase()));

    return <AssetTagList items={matchingTags.map(tag => ({ id: tag.id, label: tag.name }))} icon={props.icon} />;
};
